import axios, { refreshSession } from './BaseService';
import { clearToken, setToken } from './tokenStore';

const API_URL =
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL;

// Non secret UI flags. The access token itself is never kept here.
const SESSION_KEYS = ['hasFutures', 'hasLaunch', 'hasStrategies', 'id'];
// Objects stored as JSON (a plain setItem would stringify to "[object Object]").
const SESSION_JSON_KEYS = ['planLimits'];

export async function doLogin(email, password) {
    const loginUrl = `${API_URL}/auth/login`;
    const response = await axios.post(loginUrl, {
        email,
        password,
    });
    return response.data;
}

export async function requestPasswordReset(email) {
    const response = await axios.post(`${API_URL}/auth/forgot-password`, {
        email,
    });
    return response.data; //{message}
}

export async function doLogout() {
    const logoutUrl = `${API_URL}/auth/logout`;
    const response = await axios.post(logoutUrl, {});
    return response.data;
}

export function storeSession(session) {
    setToken(session.token);
    SESSION_KEYS.forEach(key => localStorage.setItem(key, session[key]));
    SESSION_JSON_KEYS.forEach(key => {
        if (session[key] === undefined) localStorage.removeItem(key);
        else localStorage.setItem(key, JSON.stringify(session[key]));
    });
}

export function clearSession() {
    clearToken();
    SESSION_KEYS.forEach(key => localStorage.removeItem(key));
    SESSION_JSON_KEYS.forEach(key => localStorage.removeItem(key));
}

// Called once before the app renders: a reload lost the in-memory token, but
// the httpOnly refresh cookie can still mint a new one.
export async function restoreSession() {
    // Older builds kept the token in localStorage.
    localStorage.removeItem('token');
    try {
        storeSession(await refreshSession());
    } catch (err) {
        clearSession();
    }
}
